export default __webpack_public_path__ + "static/media/E&W.b382afbd.pdf";